import { ref, watch } from 'vue'

const KEY = 'app-theme'
const night = ref(localStorage.getItem(KEY) === 'night')

watch(
  night,
  (on) => {
    const isAdmin = typeof location !== 'undefined' && location.pathname.startsWith('/admin')
    document.documentElement.classList.toggle('night', !!on && !isAdmin)
    localStorage.setItem(KEY, on ? 'night' : 'day')
  },
  { immediate: true }
)

export function useTheme() {
  const toggleNight = () => {
    night.value = !night.value
  }
  const setNight = (on) => {
    night.value = !!on
  }
  return { night, toggleNight, setNight }
}
